import { cn } from "~/utils/fontsConfig";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Skeleton = ({ className, ...props }: SkeletonProps) => {
    return (
        <div
            className={cn("animate-pulse rounded-md bg-v3-N-400", className)}
            {...props}
        />
    );
};
